module.exports = __webpack_public_path__ + "front/img/logo-7.f31965f1.png";